import styles from './PlacingOrderDatePicker.module.scss';
import Box from '@components/Box';
import cn from 'classnames';
import PlacingOrderTitle from '../PlacingOrderTitle';
import SingleDatePicker from '@components/SingleDatePicker';
import { Column, Row } from '@components/Grid';
import { formatDate } from '@utils/formatValues';
import { IPlacingOrderDatePickerProps } from '../../types';
import { useTranslation } from 'react-i18next';

const PlacingOrderDatePicker: React.FC<IPlacingOrderDatePickerProps> = (props: IPlacingOrderDatePickerProps): React.ReactElement => {
  const {
    country,
    handlerUpdateForm,
    isNew,
    shipmentDates,
    withDateButtons,
    withDatePicker
  } = props;

  const { t } = useTranslation();

  const checkDates = (shipmentDate: Date, currentDate: Date | undefined): boolean => {
    return formatDate(shipmentDate, 'dd.MM.yyyy') === formatDate(currentDate, 'dd.MM.yyyy');
  };

  const setSelectedDate = (value: Date | ((prev: Date | undefined) => Date | undefined) | undefined) => {
    if (value instanceof Date) {
      handlerUpdateForm(country, 'shipmentDates.selected', value);
    }
  };

  return (
      <>
        <PlacingOrderTitle title={t('placingOrderModalWindow.datePicker.title')}/>
        <Row>
          <Column phone={12}>
            <Box mb={8}>
              <div className={withDateButtons ? styles.dates : styles.picker}>
                {withDateButtons && (
                    shipmentDates.values.map((item: Date, index: number) => (
                            <button
                                className={cn(styles.dateItemBtn, checkDates(item, shipmentDates.selected) && styles.dateItemBtnSelected)}
                                disabled={withDatePicker ? index < 2 ? isNew : false : false}
                                key={index}
                                onClick={() => setSelectedDate(item)}
                            >
                              {withDatePicker ? index ? formatDate(item, 'dd.MM') : t('placingOrderModalWindow.datePicker.tomorrow') : formatDate(item, 'dd.MM')}
                            </button>
                        )
                    )
                )}
                {withDatePicker && (
                    <SingleDatePicker
                        handlerSetSelectedDate={setSelectedDate}
                        isNew={isNew}
                        placeholder={t('placingOrderModalWindow.datePicker.selectDate')}
                        right={withDateButtons ? 0 : -113}
                        selectedDate={shipmentDates.selected}
                        top={46}
                    />
                )}
              </div>
            </Box>
          </Column>
        </Row>
      </>
  );
};

export default PlacingOrderDatePicker;